import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api';
import { UNIT_SELECT_CARD } from '../constants/unitsMeta';

function StatPill({ children }) {
  return <span className="unit-select-pill">{children}</span>;
}

export default function UnitSelect() {
  const [me, setMe] = useState(null);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/api-me')
      .then((data) => {
        if (!cancelled) setMe(data);
      })
      .catch((err) => {
        if (!cancelled) setLoadError(err.message || 'Błąd');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const user = me?.user;
  const stats = me?.stats;
  const adminUnits = me?.adminUnits || [];
  const canPreview = me?.canMultiUnitPreview;
  const mpOnlyModeEnabled = !!me?.mpOnlyModeEnabled;
  const canAccessAllUnits = canPreview || !mpOnlyModeEnabled;
  const visibleCards = canAccessAllUnits
    ? UNIT_SELECT_CARD
    : UNIT_SELECT_CARD.filter((c) => c.unit === 'mp');

  return (
    <div className="form-page unit-select-page">
      <div className="form-container unit-select-container">
        <header className="form-header unit-select-header">
          <div className="unit-select-header__text">
            <h1>Wybór jednostki</h1>
            <p className="unit-select-subtitle">
              Każda jednostka ma osobny dashboard, formularz podania i skargi. Wybierz tę, w której działasz —
              dane i tickety są rozdzielane per MP / CID / QRF.
            </p>
          </div>
        </header>

        {user && (
          <div className="unit-select-user">
            <img
              src={user.avatar_url || 'https://cdn.discordapp.com/embed/avatars/0.png'}
              alt=""
              className="unit-select-user__avatar"
            />
            <div className="unit-select-user__meta">
              <div className="unit-select-user__line">
                <span className="unit-select-user__hello">Cześć,</span>{' '}
                <strong>{user.username}</strong>
                {adminUnits.length > 0 && (
                  <span className="unit-select-user__admin">Administrator ({adminUnits.join(', ').toUpperCase()})</span>
                )}
              </div>
              {stats && (
                <div className="unit-select-user__stats">
                  <StatPill>
                    Podania: <strong>{stats.applications}</strong>
                    {stats.applications_pending > 0 && (
                      <span className="unit-select-user__pending"> · {stats.applications_pending} oczekuje</span>
                    )}
                  </StatPill>
                  <StatPill>
                    Skargi: <strong>{stats.complaints}</strong>
                    {stats.complaints_pending > 0 && (
                      <span className="unit-select-user__pending"> · {stats.complaints_pending} oczekuje</span>
                    )}
                  </StatPill>
                </div>
              )}
            </div>
          </div>
        )}

        {loadError && <p className="unit-select-error">{loadError}</p>}

        {canPreview && (
          <Link to="/jednostki/overview" className="unit-select-preview-card">
            <span className="unit-select-preview-card__badge">Podgląd</span>
            <div className="unit-select-preview-card__body">
              <strong>Wszystkie jednostki naraz</strong>
              <span>
                Statystyki i skróty do MP, CID i QRF na jednym ekranie — dostęp tylko dla uprawnionych kont.
              </span>
            </div>
            <span className="unit-select-preview-card__cta">Otwórz podgląd →</span>
          </Link>
        )}

        <div className="unit-select-grid">
          {visibleCards.map(({ unit, title, desc, emoji }) => {
            const isUnitAdmin = adminUnits.includes(unit);
            return (
              <div key={unit} className="unit-select-card-wrap">
                <Link to={`/${unit}/dashboard`} className="unit-select-card">
                  <span className="unit-select-card__emoji" aria-hidden>
                    {emoji}
                  </span>
                  <strong className="unit-select-card__title">{title}</strong>
                  <span className="unit-select-card__desc">{desc}</span>
                  {isUnitAdmin && <span className="unit-select-card__admin-tag">Masz panel admin</span>}
                </Link>
                <nav className="unit-select-card__actions" aria-label={`Skróty ${title}`}>
                  <Link to={`/${unit}/dashboard`}>Dashboard</Link>
                  <span className="unit-select-card__dot" aria-hidden>
                    ·
                  </span>
                  <Link to={`/${unit}/application`}>Podanie</Link>
                  <span className="unit-select-card__dot" aria-hidden>
                    ·
                  </span>
                  <Link to={`/${unit}/complaint`}>Skarga</Link>
                  {isUnitAdmin && (
                    <>
                      <span className="unit-select-card__dot" aria-hidden>
                        ·
                      </span>
                      <Link to={`/${unit}/admin`} className="unit-select-card__actions-admin">
                        Admin
                      </Link>
                    </>
                  )}
                </nav>
              </div>
            );
          })}
        </div>

        <footer className="unit-select-foot">
          <p>
            <strong>Wskazówka:</strong> jeśli jesteś na kilku serwerach jednostek, wybierz tę samą stronę co aktywna
            rekrutacja — ticket na Discord utworzy się w odpowiedniej gildii.
          </p>
        </footer>
      </div>
    </div>
  );
}
